<template>
  <div class="job-card">
    <a :href="item.viewUrl" :title="linkTitle" :target="linkTarget">
      <!-- <div class="card-header flex-justify-between"> -->
      <div class="card-header">
        <span class="job-tag type2" v-if="item.annType === 'JB'">가치동행일자리</span>
        <span class="job-tag type1" v-else-if="item.BIZ_SE === 'IN49001'">{{ item.BIZ_SE_NM }}</span>
        <span class="job-tag type2" v-else-if="item.BIZ_SE === 'IN49003'">{{ item.BIZ_SE_NM }}</span>
        <span class="job-tag type3" v-else-if="item.BIZ_SE === 'IN49006'">{{ item.BIZ_SE_NM }}</span>
        <span class="job-tag type4" v-else-if="item.BIZ_SE === 'IN49007'">{{ item.BIZ_SE_NM }}</span>
        <span class="job-tag type5" v-else-if="item.BIZ_SE === 'IN49008'">{{ item.BIZ_SE_NM }}</span>
        <span class="job-tag type1" v-else-if="item.BIZ_SE === 'IN49009'">{{ item.BIZ_SE_NM }}</span>
        <span class="job-tag type2" v-else-if="item.BIZ_SE === 'IN49004'">{{ item.BIZ_SE_NM }}</span>
        <span class="mark" v-if="showMark">
          <img src="img/common/ico-mark01.svg" alt="이수" />
        </span>
        <button
          v-if="showFavoriteButton"
          class="like-button"
          :class="{'is-active': favoriteStatus}"
          :aria-label="favoriteStatus ? '관심 선택됨' : '관심 등록'"
          :title="favoriteStatus ? '관심 선택됨' : '관심 등록'"
          @click.prevent="handleFavoriteClick"
        >
          <i class="ico ico-favor"></i>
        </button>
      </div>
      <div class="card-body">
        <slot name="title">
          <a href="javascript:void(0);" class="title-line" title="{{ item.ANN_NM }} 상세보기">
            {{ item.ANN_NM }}
          </a>
        </slot>
        <slot name="details">
          <p class="job-details" v-if="item.annType === 'IN'">
            활동비 시급 : <strong>{{ item.actamtHamt }}원</strong> <br/>
            {{ item.workConditionLabel }} <span class="bar"></span> 신입
          </p>
          <p class="job-details" v-else>
            운영기관 : {{ item.OPER_ORG_NM }}
            <br>
            사업구분 : {{ item.BIZ_SE_NM }}
          </p>
        </slot>
        <slot name="recruitment-info">
          <div class="recruitment-info">
            <span>모집인원 : <strong>{{ item.rcptPpl }}명</strong></span>
            <span>모집기간 : <strong>{{ item.APPDURNG_STED }}</strong></span>
          </div>
        </slot>
      </div>
      <div class="card-footer" v-if="showFooter">
        <button class="status-button apply" v-if="item.ANN_RCRT_STAT.includes('17003')">
          신청 · 접수하기 <span>(D{{ item.DDAY }})</span>
        </button>
        <button class="status-button" v-else-if="item.ANN_RCRT_STAT.includes('17002')">
          모집 예정입니다 <span>(D{{ item.DDAY }})</span>
        </button>
        <button class="status-button" v-else-if="item.ANN_RCRT_STAT.includes('17004')">
          마감되었습니다
        </button>
      </div>
    </a>
  </div>
</template>

<script>
export default {
  name: 'JobCard',
  props: {
    item: {
      type: Object,
      required: true,
    },
    showMark: {
      type: Boolean,
      default: true,
    },
    showFavoriteButton: {
      type: Boolean,
      default: true,
    },
    showFooter: {
      type: Boolean,
      default: true,
    },
    linkTitle: {
      type: String,
      default: '공고 상세페이지로 이동',
    },
    linkTarget: {
      type: String,
      default: '_blank',
    },
  },
  computed: {
    favoriteStatus() {
      // 두 가지 형태의 favorite 상태를 지원
      return this.item.isFavorite || this.item.FAVORITE_YN === 'Y';
    },
  },
  methods: {
    handleFavoriteClick() {
      this.$emit('favorite-toggle', this.item);
    },
  },
};
</script>



// WEBPACK FOOTER //
// JobCard.vue?5f7cf11e